import { useMemo } from 'react'
import { useRecurrenceDispatch } from '../../../../../providers/StateProvider'
import { useTexts } from './useTexts'

export function useRecurrenceEndOccurrenceProps(value: number) {
  const dispatch = useRecurrenceDispatch()
  const texts = useTexts()

  return useMemo(
    () => ({
      label: '',
      info: texts.info(value),
      value,
      onChange: (numOfRecurrencesRequired: number) => {
        dispatch({
          type: 'recurrenceEnd:change',
          recurrenceEnd: {
            endType: 'AFTER_NUMBER',
            numOfRecurrencesRequired,
          },
        })
      },
    }),
    [texts, value, dispatch],
  )
}
